import useStore from "../../../store"
import { useState } from "react"
import { useNavigate } from "react-router-dom"
import HighlightMatch from "../../../utilities/HighlightMatch"
import vciDealerStatus from "../../../utilities/vciDealerStatus"
import { NeutralButton } from "../../common/Buttons"
import Spinner from "../../common/Spinner"


export default function VCIDealerRow({ dealer, searchTerm }) {
  const navigate = useNavigate()
  const status = vciDealerStatus(dealer)
  const createFieldAudit = useStore((state) => state.createFieldAudit)

  const [creatingFieldAudit, setCreatingFieldAudit] = useState(false)

  const handleButtonClick = () => {
    if (dealer.attributes['current-field-audit-id']) {
      navigate(`/field_audits/${dealer.attributes['current-field-audit-id']}`)
    } else {
      setCreatingFieldAudit(true)
      createFieldAudit(dealer.id, (fieldAudit) => {
        navigate(`/field_audits/${fieldAudit.id}`)
        setCreatingFieldAudit(false)
      })
    }
  }

  const buttonText = () => {
    if (creatingFieldAudit) {
      return <Spinner height="25px" />
    } else if (dealer.attributes['current-field-audit-id']) {
      return 'Resume Audit'
    } else {
      return 'Start Audit'
    }
  }

  return (
    <div
      className='flex w-full items-center border-b-2 border-grey-700
        p-2 text-grey-300 text-left lg:hover:bg-grey-700'
      onClick={() => console.log('clicked')}
    >
      <div className="flex flex-col w-1/2 md:w-2/3">
        <div className="text-sm">
          <HighlightMatch
            str={dealer.attributes['city-state']}
            match={searchTerm}
            truncate={true}
          />
        </div>

        <div className="font-bold text-lg text-grey-100">
          <HighlightMatch
            str={dealer.attributes.name}
            match={searchTerm}
            truncate={true}
          />
        </div>

        <div className={`${status.style} text-xs`}>
          {status.text}
        </div>
      </div>

      <div className="flex justify-end w-1/2 md:w-1/3">
        <NeutralButton
          text={buttonText()}
          onClick={handleButtonClick}
        />
      </div>
    </div>
  )
}